import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import Notifications from 'vue-notification'
import VueTheMask from 'vue-the-mask'
// import { INITIALIZATION } from './modules/auth/store/mutation-types'

import router from './router'
import store from './store'
import i18n from './i18n'

import './assets/sass/app.sass'

Vue.use(BootstrapVue)
Vue.use(VueTheMask)
Vue.use(Notifications)

Vue.config.productionTip = false

window._Vue = new Vue({
    i18n,
    router,
    store,
    beforeCreate () {
        this.$store.dispatch('auth/InitializationStore')
    },
    render: h => h(App)
}).$mount('#app')
